var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.tableExtended = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }
    
    var debugWidget = widget.data('id') === 'aafcc205-d94a-4cb8-8254-3ee9b17bea7b';

    function renderImpl(widget, chart, data, metadata) {
        MDB.Charts.emptyChartAndMakeVisible(widget, chart);
        chart.css('height', MDB.Charts.calculateKendoChartMaxHeight(widget));

        var container = $('<div class="kendoGrid table table-bordered">').outerWidth('100%').outerHeight('100%');

        var useLegacyKeyTransform = metadata && metadata.KendoConfig && metadata.KendoConfig._UseLegacyKeyTransformation;

        var aliases = MDB.Charts.getColumnAliasses(widget);
        var keyMappings = MDB.Charts.transformKeysToKendoFields(data, useLegacyKeyTransform);

        var columns = [],
            fields = {};

        var encoded = true;
        var dateFormat = 'dd-MM-yyyy hh:mm:ss'; //Default format
        
        
        if(metadata.KendoConfig){
            if (metadata.KendoConfig.encoded === false) {
                encoded = false;
            }

            if(metadata.KendoConfig.dateFormat) {
                dateFormat = metadata.KendoConfig.dateFormat;
            }
        }

        var tableLegend = MDB.Charts.parseTableLegend(metadata && metadata.KendoConfig ? metadata.KendoConfig : {}, _.map(keyMappings, 'originalKey'), aliases);
        
        _.forEach(keyMappings, function (keyMapping, i) {
            var originalKey = keyMapping.originalKey,
                key = keyMapping.field,
                format = tableLegend.getFormat(i);
            
            if(!format){
                format = metadata.ColumnTypes[originalKey] === 'date' ?
                    '{0:' + dateFormat + '}' :
                    metadata.ColumnFormats[originalKey] ? '{0:' + metadata.ColumnFormats[originalKey] + '}' : '';
            }

            //keys[i] = key = '__field'+i;
            fields[key] = { type: metadata.ColumnTypes[originalKey] };
            columns[i] = {
                originalKey: originalKey,
                field: key,
                headerTemplate: function () {
                    var header = $('<span />', {class: 'd-block'});

                    header.text(tableLegend.getHeaderText(i));
                    header.css(tableLegend.getStyle(i));

                    var tooltip = tableLegend.getTooltipText(i);
                    if (tooltip){
                        tooltip = $('<i />', { 'class': 'fa fa-info ml-1 header-tooltip', 'data-title': tooltip });
                        tooltip.css({ 'font-size': tableLegend.getIconFontSize(i)});
                        header.append(tooltip);
                    }

                    return $('<div />').append(header).html();
                },
                encoded: encoded,
                format: format
            };
        });
        
        
        
        /* * * * * *
         * For scaling: autoScaleHeight = true
         *    If scaling is enabled and the pageSize > 0 than the table will be resized to fit all the rows in 1 page (including the page buttons)
         *    If the pageSize = 0 than all rows will be displayed and the page buttons are rendered out of view
         */
        //The custom scaling implementation goes by the table's scrollheight property, so we need to set scrollable to true when the table is pageable and autoscaling
        var scrollable = !metadata.KendoConfig.autoScaleHeight || (metadata.KendoConfig.pageable && metadata.KendoConfig.pageable.pageSize > 0);

        var kendoConfig = {
            columns: columns,
            dataSource: {
                data: data,
                schema: {
                    model: {
                        fields: fields
                    }
                }
            },
            scrollable: scrollable,
            pageable: metadata.KendoConfig.pageable ? MDB.KendoConfigBuilder.gridPageableSettings() : false
        };

        if (metadata.KendoConfig) {
            $.extend(true, kendoConfig, metadata.KendoConfig);
        }

        if (kendoConfig.excel) {
            kendoConfig.excel.fileName =
                sprintf('%s_%s.xlsx', widget.find('.box-title').text(), $('.dashboard-dateselector').val()).replace(/\s+/g, '_');

            // force the proxy to support large files
            kendoConfig.excel.proxyURL = '/Proxy/KendoUI';
            kendoConfig.excel.forceProxy = true;            
        }

        chart.append(container);
        container.kendoGrid(kendoConfig);
        
        container.kendoTooltip({
            filter: 'th .header-tooltip[data-title]',
            position: 'bottom',
            width: 400,
            animation: {
                open: {
                    effects: "zoom",
                    duration: 150
                }
            },
            content: function (e) {
                return kendo.htmlEncode($(e.target).data('title')).replace('\n', '<br />');
            }
        });
        
        // For some reason an empty filter row appears if scrollable is set to false.
        if (!scrollable && container.find('.k-filter-row').length > 1) {
            container.find('.k-filter-row').first().remove();
        }

        if (kendoConfig.hideHeader) {
            container.find('.k-grid-header').hide();
        }
        
        if (kendoConfig.pageable && kendoConfig.pageable.pageSize > 0 && kendoConfig.autoScaleHeight) {
            var tableRows = container.find('.k-grid-content');
            var hiddenHeight = tableRows.prop('scrollHeight') - tableRows.height();

            if (hiddenHeight > 0) {
                var box = widget.find('.box-primary');
                box.height(box.height() + hiddenHeight);
                chart.height(chart.height() + hiddenHeight);
                tableRows.height(tableRows.prop('scrollHeight'));
                MDB.Charts.storeUpdatedPositionFromDOM(widget);
            }

            return true;
        }
    }

    setTimeout(function() {
        MDB.Charts.renderers.tableGeneric(widget, chart, data, metadata, renderImpl);
    }, 0);
};